import React from 'react';
const SkipToMain = () => <a tabIndex="-1" id="main-content" className="sr-only"></a>
export default SkipToMain;